<script setup lang="ts">
/**
 * @changelog
 *
 * 2026-03-11 (0.1.0) (jhoward)
 *   - Add CountdownCallToAction.vue for redirecting after countdown.
 *
 * 2026-04-09 (0.1.1) (jhoward)
 *   - Add secondsUntilRedirect prop and update countdown logic in CountdownCallToAction.vue.
 */ import type { PropType } from 'vue';
import { onMounted, onUnmounted, ref } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import router from '@/router';

const props = defineProps({
  ctaRoute: {
    type: Object as () => RouteLocationRaw | null,
    default: null,
  },
  secondsUntilRedirect: {
    type: Number as PropType<number | null>,
    default: 10,
  },
});

const redirectSeconds = ref<number>(props.secondsUntilRedirect || 0);
let redirectInterval = -1;

onMounted(() => {
  if (props.ctaRoute && null !== props.secondsUntilRedirect) {
    redirectInterval = setInterval(() => {
      if (redirectSeconds.value > 0) {
        redirectSeconds.value -= 1;
      } else {
        clearInterval(redirectInterval);
        if (props.ctaRoute) {
          router.push(props.ctaRoute as RouteLocationRaw);
        }
      }
    }, 1000);
  }
});

onUnmounted(() => {
  clearInterval(redirectInterval);
});
</script>

<template>
  <div v-if="ctaRoute">
    <p v-if="null !== secondsUntilRedirect">You will be redirected in {{ redirectSeconds }} seconds.</p>
    <router-link :to="ctaRoute" class="material-button">Click to Continue Now</router-link>
  </div>
</template>

<style scoped></style>
